if (!customElements.get('holiday-catalog-cta')) {
  customElements.define('holiday-catalog-cta', class extends HTMLElement {
    connectedCallback() {
      const cards = this.parentElement?.querySelectorAll(':scope > .listing-card');
      const lastCard = cards?.[cards.length - 1];
      if (!lastCard) return;
      const measure = () => {
        const height = Math.ceil(lastCard.getBoundingClientRect().height);
        if (height > 0 && this.style.minHeight !== `${height}px`) this.style.minHeight = `${height}px`;
      };
      this.observer = new ResizeObserver(measure);
      this.observer.observe(lastCard);
      measure();
    }
    disconnectedCallback() {
      this.observer?.disconnect();
    }
  });
}
